import React from 'react';
import { Modal } from "@livingdesign/react";

export const QA_ID_PREFIX = "ModalLD3";

function ModalLD3({
    children,
    title,
    onClose,
    isOpen,
    actions,
    UNSAFE_className,
    UNSAFE_style,
    size,
    id,
}){
    return (
        <Modal
            title={title}
            onClose={onClose}
            isOpen={isOpen}
            actions={actions}
            closeButtonProps={{
                "aria-label": "Close Modal",
                "data-testid": `${QA_ID_PREFIX}-close-button`
            }}
            UNSAFE_className={UNSAFE_className}
            UNSAFE_style={UNSAFE_style}
            size={size}
            id={`${id}-${QA_ID_PREFIX}`}
            data-testid={`${QA_ID_PREFIX}-modal`}
        >
            {children}
        </Modal>
    )
}

export default ModalLD3;